let activityTimeout = null;
let eventListenersAdded = false;
let onTimeoutCallback = null;

const TIMEOUT_DURATION = 15 * 60 * 1000; // 15 minutes default activity log-out threshold

const resetTimer = () => {
  if (activityTimeout) {
    clearTimeout(activityTimeout);
  }
  activityTimeout = setTimeout(() => {
    if (onTimeoutCallback) {
      onTimeoutCallback();
    }
  }, TIMEOUT_DURATION);
};

export const setupActivityListener = (callback) => {
  onTimeoutCallback = callback;
  resetTimer();

  if (!eventListenersAdded) {
    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('mousedown', resetTimer);
    window.addEventListener('keypress', resetTimer);
    window.addEventListener('scroll', resetTimer);
    window.addEventListener('touchstart', resetTimer);
    eventListenersAdded = true;
  }
};

export const removeActivityListener = () => {
  if (activityTimeout) {
    clearTimeout(activityTimeout);
    activityTimeout = null;
  }
  if (eventListenersAdded) {
    window.removeEventListener('mousemove', resetTimer);
    window.removeEventListener('mousedown', resetTimer);
    window.removeEventListener('keypress', resetTimer);
    window.removeEventListener('scroll', resetTimer);
    window.removeEventListener('touchstart', resetTimer);
    eventListenersAdded = false;
  }
  onTimeoutCallback = null;
};
